import displayListing from "../modules/dispay-listings-each/display";
import firebase from "./firebase";
import inAppNotification from "./in-app-notification";
import openUrls from "./open-app-urls/open-urls";

class installApp {
  #isOniOS = false;
  #promtLoaded = false;
  #needsInstalation = false;
  #deferredPrompt;
  #eventsInitialized = false;
  constructor() {
    // TODO later add iOS install CTA


    // console.error('Install called. In DEV mode. NV is in test mode.');
    // console.error('Install not called. In DEV mode. Should be turned back on fro production.');

    // this._initiateInstallApp();

    // setTimeout(() => {
    //   this._IOSInstalled();
    // }, 1000);
  }

  _getMobileOS() {
    const userAgent =
      window.navigator.userAgent || window.navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return "Android";
    }

    return "Other"; // Desktop or something else
  }

  _IOSInstalled() {
    if (this._getMobileOS() === "iOS") {
      const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true; // For iOS Safari

      if (!isStandalone) {
        this.#isOniOS = true;
        this._showInstallModule();
        this._events();
      }
    }
  }
  _setPromtLoaded() {
    console.warn("trigered");
    this.#promtLoaded = true;
  }

  _getNeedsInstalation() {
    return this.#needsInstalation;
  }

  _installNow() {
    if (this.#isOniOS) {
      displayListing._myOwnImgDisplayerNotAIs([
        "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/instructions%20imgs%2FiOS%20install%20instructions%20margin.png?alt=media&token=c5b8cbf3-753f-4018-9606-7b8855bf657e",
      ]);
      // displayListing._myOwnImgDisplayerNotAIs([
      //   "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/instructions%20imgs%2FiOS%20install%20instructions.png?alt=media&token=2a20d689-9b54-467d-bcbe-fcfacc387f5b",
      // ]);
      return;
    }

    this.#deferredPrompt.prompt();
    this.#deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
      } else {
        console.log("User dismissed the A2HS prompt");
        setTimeout(() => {
          inAppNotification._showNotification(
            "¿Ya estás convencido? ¡Puede ser más fácil!",
            "Si estás disfrutando esta aplicación, instálalo ahora y lo tendrás a un solo click.",
            "Si quiero instalar",
            "installmodule",
            12000
          );
        }, 420000);
      }
      this.#deferredPrompt = null;
      // Hide the button after installation attempt
      PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
    });
  }

  _showInstallModule() {
    console.error("trigered");
    // const PreInstallCon = document.getElementById("PreInstallCon");
    // PreInstallCon.classList.add("PrePageConForInstallationConDisplay");
    const CTAInstallApp = document.getElementById("CTAInstallApp");
    CTAInstallApp.style.display = "flex";
  }

  // Function to wait until this.#promtLoaded is true
  async #waitForPromptLoaded() {
    while (!this.#promtLoaded) {
      // Sleep for a short time before checking again
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }

  _events() {
    if (this.#eventsInitialized) return;
    this.#eventsInitialized = true;
    const CTAInstallAppButtonClose = document.getElementById(
      "CTAInstallAppButtonClose"
    );

    const installButton = document.getElementById("CTAInstallAppButtonInstall");
    // const PreInstallCon = document.getElementById("PreInstallCon");
    // PreInstallCon.classList.add("PrePageConForInstallationConDisplay");


    const CTAInstallApp = document.getElementById("CTAInstallApp");
    CTAInstallApp.style.display = "flex";


    this.#needsInstalation = true;

    // Trigger the install prompt when the button is clicked
    installButton.addEventListener("click", () => {
      this._installNow();
    });
    CTAInstallAppButtonClose.addEventListener("click", () => {
      CTAInstallApp.style.display = "none";
      //   this.#deferredPrompt = null;
      // PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
      // setTimeout(() => {
      //   inAppNotification._showNotification(
      //     "¿Quieres Instalar Mercado MAI?",
      //     "Si estás disfrutando esta aplicación, instálalo ahora y lo tendrás a un solo click.",
      //     "Instalar ahora",
      //     "installnow",
      //     12000
      //   );
      // }, 300000);
    });

  }

  async _initiateInstallApp() {
    // // Start Installation

    // Listen for the beforeinstallprompt event
    window.addEventListener("beforeinstallprompt", async (e) => {
      // Prevent the default installation prompt
      e.preventDefault();
      this.#deferredPrompt = null;
      // Storing the event to trigger it later
      this.#deferredPrompt = e;
      // Show the install button
      await this.#waitForPromptLoaded();
      this._events();
    });

    // Listen for the appinstalled event to track the installation
    window.addEventListener("appinstalled", async (e) => {
      console.log("PWA was installed");

      const result = await firebase._registerPWAInstalls(
        openUrls._getGatheredUserData()
      );
      console.log(result);

      this.#needsInstalation = false;

      // Optionally, you can hide the button permanently once the app is installed
      PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
    });
  }
}
export default new installApp();
